import React, { memo, useEffect, useRef, useState } from "react";
import moment from "moment";
import { EngineMode } from "../../../types";
import { selectionStore } from "../../../stores/selection.store";
import { moduleSettings } from "../../../stores/module-settings.store";
import calendarService from "../../../services/calendar-service";
import { selectionStoreChangesService } from "../../../services/selection-store-changes.service";
import { GolEventListener } from "../calendar";
import GolDayPickerSingleDateController from "./gol-day-picker-single-date-controller";

const GolCalendar = () => {
  const lastBookingDate =
    moduleSettings.last_booking_date === "-1" ||
    moduleSettings.last_booking_date === null
      ? moment().add(2, "years")
      : moment(moduleSettings.last_booking_date);
  const [numberOfMonthToAdd, setNumberOfMonthToAdd] = useState(0);
  const [, setSelectedDate] = useState(selectionStore.date);
  const selectedEngineMode = useRef<EngineMode>(EngineMode.capacity);

  useEffect(() => {
    if (0 === numberOfMonthToAdd) return;
    selectionStore.updateCalendateDate(numberOfMonthToAdd);
    selectionStoreChangesService.dispatch(GolEventListener.CalendarMonth);
    return () => {};
  }, [numberOfMonthToAdd]);

  const onNextMonth = () => {
    setNumberOfMonthToAdd(1);
  };

  const onPrevMonth = () => {
    setNumberOfMonthToAdd(-1);
  };

  const onDateChange = (momentDate: any) => {
    selectionStore.updateDate(momentDate);
    setSelectedDate(selectionStore.date);
    selectionStoreChangesService.dispatch(GolEventListener.CalendarDate);
    selectedEngineMode.current = calendarService.getEngineMode(momentDate);
    // selectionStore.resetSelectedArea(selectedEngineMode.current);
  };

  const hasPrevMonth = (): boolean => {
    return (
      selectionStore.calendarDate.clone().diff(calendarService.DATE_NOW) > 0
    );
  };

  const hasNextMonth = (): boolean => {
    return (
      selectionStore.calendarDate
        .clone()
        .endOf("month")
        .diff(lastBookingDate) <= 0
    );
  };

  return (
    <div data-test="gol-day-picker-single-date-controller">
      <GolDayPickerSingleDateController
        onDateChange={onDateChange}
        hasNextMonth={hasNextMonth()}
        hasPrevMonth={hasPrevMonth()}
        numberOfMonths={1}
        onNextMonth={onNextMonth}
        onPrevMonth={onPrevMonth}
        selectedDate={selectionStore.date!}
        lastBookingDate={lastBookingDate}
        calendarDate={selectionStore.calendarDate}
      />
    </div>
  );
};

export default memo(GolCalendar);
